import { render, staticRenderFns } from "./CommonSettings.vue?vue&type=template&id=0f68bc30&scoped=true&lang=html&"
import script from "./CommonSettings.vue?vue&type=script&lang=js&"
export * from "./CommonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68bc30",
  null
  
)

export default component.exports